import fp from 'lodash/fp'
import { createElement } from 'react'
import { getColumnClassName, getRowClassName } from './helpers'

const Grid = fp.prop('children')

// Check http://flexboxgrid.com/ for more information about API
const Row = (props) =>
  createElement('div', {
    ...props,
    className: `row ${getRowClassName(props)}`,
  })

const Col = (props) =>
  createElement('div', {
    ...props,
    className: getColumnClassName(props),
  })

export { Grid, Row, Col }
